export default __webpack_public_path__ + "static/media/left-hover.09c6bcfa.svg";